<template>
  <div
    class="primeira-consulta"
    v-if="modal && modal.tipo === 'primeira-consulta' && modal.item"
  >
    <div class="linha-tempo-container">
      <!-- CABEÇALHO -->
      <!-- <div class="header">
        <h1>📅 Linha do tempo da gestante</h1>
        <p class="header-subtitle">
          C3 Gestação e Puerpério – visão geral do período gestacional e
          puerperal utilizado para avaliação do indicador.
        </p>
      </div> -->

      <div class="d-flex align-center justify-content-end mb-4">
        <modal-ajuda-cids-ciaps
          card-page="gestantes-puerperas"
          :grupo-filtro="[]"
          :ciap="['PARTO', 'ABORTO', 'GRAVIDEZ']"
          :cid="['PARTO', 'ABORTO', 'GRAVIDEZ']"
          :sigtap="[
            'HIV',
            'SIFILIS',
            'HEPATITEB',
            'HEPATITEA',
            'GRAVIDEZ',
            'PARTO',
          ]"
        />
      </div>

      <!-- INFO BOX (cabecalho com datas principais) -->
      <div class="info-box">
        <h3>Informações da gestante</h3>
        <div class="info-grid">
          <div class="info-item">
            <strong>1ª Consulta</strong>
            <span>{{ formatDate(modal.item.dt_prim_cons_pn) || '-' }}</span>
          </div>
          <div class="info-item">
            <strong>DUM</strong>
            <span>{{ formatDate(modal.item.dum) || '-' }}</span>
          </div>
          <div class="info-item">
            <strong>IG na 1ª consulta</strong>
            <span>{{ modal.item.ig_prim_consulta }} semanas</span>
          </div>
          <div class="info-item">
            <strong>DPP</strong>
            <span>{{ formatDate(modal.item.dpp) || '-' }}</span>
          </div>
        </div>
        <div class="info-metodologica" v-if="modal.item.ig_prim_consulta > 12">
          <strong>⚠️ Atenção:</strong>
          Gestante fez 1ª consulta pré-natal com mais de 12 semanas de gestação.
          Recomenda-se que as novas gestantes iniciem o pré-natal sempre antes
          das 12 semanas.
        </div>
      </div>

      <!-- LINHA DO TEMPO -->
      <div class="timeline">
        <!-- Período Gestacional -->
        <div class="period-block gestacao">
          <div class="period-header">
            <div class="period-title">🤰 Período Gestacional</div>
            <div class="period-duration">294 dias (42 semanas)</div>
          </div>

          <div class="period-dates">
            <strong
              >{{ formatDate(modal.item.dum) || '-' }} (DUM) →
              {{ formatDate(modal.item.dpp) || '-' }} (DPP) →
              {{ encerramentoGestacao(modal.item) }} (Encerramento no
              sistema)</strong
            >
            <br />
            <small class="muted-text">
              Da DUM até a DPP, são 280 dias ou 40 semanas;
              <br />
              Da DUM até o encerramento pelo sistema, são 294 dias ou 42
              semanas.
            </small>
          </div>

          <div class="info-metodologica">
            <strong>⚠️ Atenção:</strong>
            Mesmo com a data do parto informada, para efeitos do indicador, o
            encerramento da gestação pelo sistema considera 294 dias a partir da
            DUM.
          </div>

          <div class="consultas-recomendadas">
            <p class="consultas-titulo">Consultas recomendadas:</p>
            <div class="consultas-grid">
              <div class="consulta-item">1ª Consulta</div>
              <div class="consulta-item">2ª Consulta</div>
              <div class="consulta-item">3ª Consulta</div>
              <div class="consulta-item">4ª Consulta</div>
              <div class="consulta-item">5ª Consulta</div>
              <div class="consulta-item">6ª Consulta</div>
              <div class="consulta-item">7ª Consulta</div>
            </div>
          </div>
        </div>

        <!-- Período Puerperal  -->
        <div class="period-block puerperal">
          <div class="period-header">
            <div class="period-title">🤱 Período puerperal</div>
            <div class="period-duration">42 dias</div>
          </div>
          <div class="period-dates">
            {{ puerperioInicio(modal.item.dpp) }}
            →
            {{ puerperioFim(modal.item.dpp) }}
          </div>
          <div class="period-content">
            Acompanhamento pós-parto com consulta e visitas puerperais.<br />
            <small class="muted-text">
              42 dias para fazer a consulta puerperal e visita do Agente de
              Saúde.
            </small>
          </div>

          <div class="info-metodologica">
            <strong>⚠️ Atenção:</strong>
            Logo que gestante parir, realizar a consulta puerperal e também a
            consulta de puericultura da criança. Esse período de 42 dias é
            somente para compreensão do denominador do indicador.
          </div>

          <div class="consultas-recomendadas">
            <p class="consultas-titulo">Ações recomendadas:</p>
            <div class="consultas-grid">
              <div class="consulta-item puerperal-item">Consulta Puerperal</div>
              <div class="consulta-item puerperal-item">
                Visita do Agente de Saúde
              </div>
            </div>
          </div>
        </div>

        <!-- Quadrimestre de Avaliação -->
        <div class="period-block quadrimestre">
          <div class="period-header">
            <div class="period-title">📊 Quadrimestre de Avaliação</div>
            <div class="period-duration quadrimestre-badge">
              {{ quadrimestreAno(modal.item.dpp) }}
            </div>
          </div>

          <!-- Bloco de cálculo -->
          <div class="calculo-periodo">
            <div class="calculo-titulo">
              📅 Cálculo do Período Total (Conforme Nota Metodológica C3):
            </div>
            <div class="calculo-grid">
              <div class="calculo-row">
                <span class="calculo-tag dum">DUM</span>
                <span class="calculo-text">
                  {{ formatDate(modal.item.dum) || '-' }}
                </span>
              </div>

              <div class="calculo-row">
                <span class="calculo-op">+</span>
                <span class="calculo-tag gestacao">294 dias</span>
                <span class="calculo-text">
                  Período gestacional total (42 semanas)<br />
                  <small class="muted-text">
                    Inclui DPP (280 dias) + 14 dias de extensão
                  </small>
                </span>
              </div>

              <div class="calculo-row">
                <span class="calculo-op">+</span>
                <span class="calculo-tag puerperio"> 42 dias</span>
                <span class="calculo-text">Período puerperal</span>
              </div>

              <div class="calculo-total">
                <span class="calculo-op">=</span>
                <span class="calculo-tag total">
                  {{ dataFinalAvaliacao(modal.item.dpp) }}
                </span>
                <span class="calculo-text destaque">
                  Data final de avaliação<br />
                  <small class="muted-text">
                    Total aproximado de 336 dias após a DUM
                  </small>
                </span>
              </div>
            </div>
          </div>

          <div class="period-content" style="margin-top: 15px">
            Em todo o período anterior a
            <strong class="texto-destaque">
              {{ dataFinalAvaliacao(modal.item.dpp) }}
            </strong>
            ainda é possível registrar alguma das boas práticas recomendadas
            para a gestante ou puérpera.
          </div>

          <div class="highlight-box quadrimestre-highlight">
            <strong>💡 Resultado:</strong>
            Esta gestante será contabilizada no
            <strong>{{ quadrimestreAno(modal.item.dpp) }}</strong
            >.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import ModalAjudaCidsCiaps from '@/pages/IndicadoresAps/components/ModalAjudaCidsCiaps.vue'

export default {
  name: 'PrimeiraConsulta',
  components: {
    ModalAjudaCidsCiaps,
  },
  props: {
    modal: {
      type: Object,
      default: null,
    },
  },
  mixins: [utils],
  data() {
    return {
      showAjudaModalCidCiaps: false,
    }
  },
  methods: {
    /**
     * Converte uma string de data em objeto Date, evitando problemas de fuso em formatos com hífen
     * @param {string} str
     * @returns {Date|null}
     */
    parseDate(str) {
      if (!str) return null
      // evita problemas de fuso com "yyyy-mm-dd"
      return new Date(String(str).replace(/-/g, '/'))
    },

    /**
     * Formata uma data para o padrão brasileiro dd/mm/yyyy
     * @param {Date|string} date
     * @returns {string}
     */
    formatDateBr(date) {
      if (!date) return ''
      const d = date instanceof Date ? date : this.parseDate(date)
      if (!d || isNaN(d.getTime())) return ''
      const dia = String(d.getDate()).padStart(2, '0')
      const mes = String(d.getMonth() + 1).padStart(2, '0')
      const ano = d.getFullYear()
      return `${dia}/${mes}/${ano}`
    },

    /**
     * Calcula a data de encerramento da gestação no sistema com base no item informado. Encerramento da gestação no sistema: DPP + 14 dias (equivalente a DUM + 294)
     * @param {Object} item
     * @returns {string}
     */
    encerramentoGestacao(item) {
      if (!item) return ''
      if (item.dpp) {
        const dpp = this.parseDate(item.dpp)
        if (dpp && !isNaN(dpp.getTime())) {
          dpp.setDate(dpp.getDate() + 14)
          return this.formatDateBr(dpp)
        }
      }
    },

    /**
     * Calcula a data de início do puerpério com base na DPP
     * @param {string} dppStr
     * @returns {string}
     */
    puerperioInicio(dppStr) {
      const base = this.parseDate(dppStr)
      if (!base) return ''
      // início do puerpério: DPP + 15 dias (dia seguinte ao encerramento)
      base.setDate(base.getDate() + 15)
      return this.formatDateBr(base)
    },

    /**
     * Calcula a data de fim do puerpério com base na DPP
     * @param {string} dppStr
     * @returns {string}
     */
    puerperioFim(dppStr) {
      const base = this.parseDate(dppStr)
      if (!base) return ''

      // Encerramento da gestação = DPP + 14
      const encerramento = new Date(base)
      encerramento.setDate(encerramento.getDate() + 14)

      // Puerpério = +42 dias
      const fim = new Date(encerramento)
      fim.setDate(fim.getDate() + 42)

      return this.formatDateBr(fim)
    },

    /**
     * Calcula os períodos gestacionais em dias e semanas, com e sem os 14 dias adicionais do sistema
     * @param {string} dum
     * @param {string} dppStr
     * @returns {object}
     */
    calcularPeriodosGestacionais(dum, dppStr) {
      if (!dum || !dppStr) {
        return {
          dias_reais: 0,
          semanas_reais: 0,
          dias_com_14: 0,
          semanas_com_14: 0,
        }
      }

      // DUM - yyyy-mm-dd
      const inicio = dum

      // DPP vem dd/mm/yyyy - converter para yyyy-mm-dd
      const dpp = dppStr

      // 1) DUM -> DPP (período gestacional "real": 280 dias / 40 semanas)
      const dias_reais = this.differenceOfDaysBetweenTwoDates(inicio, dpp)
      const semanas_reais = Math.floor(dias_reais / 7)

      // 2) DUM -> DPP + 14 dias (período que o sistema mantém a gestação aberta)
      const dppMais14Date = this.parseDate(dpp)
      dppMais14Date.setDate(dppMais14Date.getDate() + 14)

      // monta yyyy-mm-dd sem usar toISOString (evita problema de UTC/fuso)
      const ano = dppMais14Date.getFullYear()
      const mes = String(dppMais14Date.getMonth() + 1).padStart(2, '0')
      const dia = String(dppMais14Date.getDate()).padStart(2, '0')
      const fim_com_14 = `${ano}-${mes}-${dia}`

      const dias_com_14 = this.differenceOfDaysBetweenTwoDates(
        inicio,
        fim_com_14
      )
      const semanas_com_14 = Math.floor(dias_com_14 / 7)

      return {
        dias_reais,
        semanas_reais,
        dias_com_14,
        semanas_com_14,
      }
    },

    /**
     * Retorna o quadrimestre e ano com base na data final do puerpério
     * @param {string} dataStr
     * @returns {string}
     */
    quadrimestreAno(dataStr) {
      const base = this.parseDate(dataStr)
      if (!base) return ''
      // fim do puerpério (mesmo cálculo da data final de avaliação)
      base.setDate(base.getDate() + 15)
      const dtFim = new Date(base)
      dtFim.setDate(dtFim.getDate() + 42)

      const mes = dtFim.getMonth() + 1
      const ano = dtFim.getFullYear()

      let quadrimestre = ''

      if (mes >= 1 && mes <= 4) {
        quadrimestre = '1º Quadrimestre'
      } else if (mes >= 5 && mes <= 8) {
        quadrimestre = '2º Quadrimestre'
      } else {
        quadrimestre = '3º Quadrimestre'
      }

      return `${quadrimestre} de ${ano}`
    },

    /**
     * Retorna a data final de avaliação com base na DPP
     * @param {string} dppStr
     * @returns {string}
     */
    dataFinalAvaliacao(dppStr) {
      return this.puerperioFim(dppStr)
    },
  },
}
</script>

<style lang="scss">
.modal-gestantes-puerperas-body {
  .primeira-consulta {
    .linha-tempo-container {
      max-width: 1200px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 20px;
      padding: 20px;
    }

    .header {
      text-align: center;
      margin-bottom: 30px;

      h1 {
        color: #667eea;
        font-size: 2.2rem;
        margin-bottom: 10px;
      }

      .header-subtitle {
        color: #666;
        font-size: 1.05rem;
      }
    }

    .info-box {
      background: #f8f9ff;
      border-left: 5px solid #667eea;
      padding: 20px;
      margin-bottom: 0px;
      border-radius: 8px;

      h3 {
        color: #667eea;
        margin-bottom: 15px;
        font-size: 1.1rem;
      }

      .info-metodologica {
        background: #ffe6e6;
        border-left: 4px solid red;
        strong {
          color: red;
        }
      }
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 15px;
    }

    .info-item {
      background: #ffffff;
      padding: 15px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      strong {
        color: #667eea;
        display: block;
        margin-bottom: 5px;
        font-size: 0.9rem;
      }

      span {
        color: #333;
        font-size: 1.1rem;
        font-weight: 600;
      }
    }

    .timeline {
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 20px 0;
    }

    .period-block {
      background: #ffffff;
      border-radius: 12px;
      padding: 25px;
      box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
      border-left: 6px solid #667eea;

      &.gestacao {
        border-left-color: #2196f3;
      }

      &.puerperal {
        border-left-color: #e91e63;
      }

      &.quadrimestre {
        border-left-color: #00695c;
      }
    }

    .period-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      flex-wrap: wrap;
      gap: 10px;
    }

    .period-title {
      color: #667eea;
      font-size: 1.4rem;
      font-weight: 700;
    }

    .period-duration {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #ffffff;
      padding: 8px 16px;
      border-radius: 20px;
      font-weight: 600;
      font-size: 0.9rem;

      &.quadrimestre-badge {
        background: linear-gradient(135deg, #00695c 0%, #004d40 100%);
      }
    }

    .period-dates {
      color: #666;
      font-size: 1rem;
      margin-bottom: 15px;
    }

    .period-content {
      color: #555;
      line-height: 1.6;
      margin-top: 10px;
      font-size: 0.95rem;

      .texto-destaque {
        color: #00695c;
      }
    }

    .muted-text {
      color: #888;
      font-size: 0.85rem;
    }

    .info-metodologica {
      background: #e8eaf6;
      border-left: 4px solid #3f51b5;
      padding: 15px;
      margin: 15px 0;
      border-radius: 8px;
      font-size: 0.9rem;

      strong {
        color: #3f51b5;
        font-size: 1rem;
      }
    }

    .consultas-recomendadas {
      margin-top: 15px;

      .consultas-titulo {
        color: #666;
        font-weight: 600;
        margin-bottom: 10px;
        font-size: 0.95rem;
      }
    }

    .consultas-grid {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 5px;
    }

    .consulta-item {
      background: transparent;
      color: #1976d2;
      padding: 8px 12px;
      border-radius: 0;
      text-align: left;
      font-weight: 500;
      font-size: 0.95rem;
      border-left: 3px solid #1976d2;
      padding-left: 15px;
      transition: none;

      &::before {
        content: '✓ ';
        margin-right: 8px;
        font-weight: bold;
      }
    }

    .consulta-item.puerperal-item {
      color: #2e7d32;
      border-left-color: #2e7d32;
    }

    .highlight-box {
      background: #fff3e0;
      border-left: 4px solid #ff9800;
      padding: 15px;
      margin-top: 15px;
      border-radius: 6px;
      font-size: 0.9rem;

      &.quadrimestre-highlight {
        background: #e0f2f1;
        border-left-color: #00695c;
      }
    }

    /* bloco de cálculo do quadrimestre */
    .calculo-periodo {
      background: #f5f5f5;
      padding: 16px;
      border-radius: 10px;
      margin: 15px 0;

      .calculo-titulo {
        font-weight: 600;
        color: #00695c;
        margin-bottom: 12px;
        font-size: 1rem;
      }

      .calculo-grid {
        display: grid;
        gap: 8px;
      }

      .calculo-row,
      .calculo-total {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
      }

      .calculo-tag {
        padding: 6px 12px;
        border-radius: 6px;
        font-weight: 600;
        min-width: 110px;
        text-align: center;
        font-size: 0.85rem;

        &.dum {
          background: #e3f2fd;
          color: #1976d2;
        }

        &.gestacao {
          background: #e8f5e9;
          color: #2e7d32;
        }

        &.puerperio {
          background: #fce4ec;
          color: #c2185b;
        }

        &.total {
          background: linear-gradient(135deg, #00695c 0%, #004d40 100%);
          color: #ffffff;
        }
      }

      .calculo-op {
        color: #00695c;
        font-size: 1.1rem;
        font-weight: bold;
      }

      .calculo-text {
        color: #666;
        font-size: 0.9rem;

        &.destaque {
          color: #00695c;
          font-weight: 600;
        }
      }

      .calculo-total {
        border-top: 2px solid #00695c;
        margin-top: 6px;
        padding-top: 8px;
      }
    }

    @media (max-width: 768px) {
      .linha-tempo-container {
        padding: 20px;
      }

      .header h1 {
        font-size: 1.6rem;
      }

      .info-grid {
        grid-template-columns: 1fr;
      }

      .period-header {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
}
</style>
